import { css } from "@emotion/react"

export const newTabWrapCss = css`
    display: flex;
    width: 100%;
    max-width: 1546px;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    gap: 10px;
    position: relative;

    svg {
        width: 100%; /* 부모 요소의 너비에 맞게 크기 조정 */
        height: auto; /* 비율을 유지하며 높이 자동 조정 */
    }

    .newTitle {
        display: flex;
        padding: 0px 273px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .authorList {
        display: flex;
        flex-direction: column; /* 세로로 배치 */
        justify-content: flex-end;
        gap: 8px;
        padding: 0px 173px;
        align-items: flex-end; /* 오른쪽 정렬 */
    }

    .bookTitle {
        display: inline-block;
        max-width: 100%; /* 제목이 너무 길어지지 않도록 */
    }

    .authorName {
        align-self: flex-end; /* 아랫줄에서 오른쪽 끝으로 정렬 */
        text-align: right;    /* 텍스트 오른쪽 정렬 */
    }
    
    .bookBg{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
       height: 100%;
       background-position: left top, right bottom; /* 배경 이미지 위치 */
        background-repeat: no-repeat; /* 반복되지 않게 설정 */
    }
    
`;

export const nextCss = css`
    position: absolute;
    top: -35px;
    right: 0;
    z-index: 2;
    cursor: pointer;
`;
export const prevCss = css`
    position: absolute;
    top: -35px;
    right: 20px;
    z-index: 2;
    cursor: pointer;
`;

